import { useState } from 'react';

const usePageable = (defaultPage, defaultRows) => {
  const [page, setPage] = useState(defaultPage);
  const [rows, setRows] = useState(defaultRows);

  return [page, rows, setPage, setRows];
};

export default usePageable;
